import Swiper, { Navigation } from "swiper";

Swiper.use([Navigation]);

(function ($, Swiper) {
	const swipe = new Swiper('.minievent.swiper', {
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 15,
		breakpoints: {
			768: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				spaceBetween: 24
			},
			992: {
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 28
			}
		},
		navigation: {
			nextEl: '.minievent .swiper-button-next',
			prevEl: '.minievent .swiper-button-prev'
		}
	});

	const swipeNews = new Swiper('.minipost.swiper', {
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 15,
		breakpoints: {
			768: {
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 30
			},
			992: {
				slidesPerView: 4,
				slidesPerGroup: 4,
				spaceBetween: 40
			}
		},
		navigation: {
			nextEl: '.minipost .swiper-button-next',
			prevEl: '.minipost .swiper-button-prev'
		}
	});

	const swipeHistoire = new Swiper('.minihistoire.swiper', {
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 15,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 30
			}
		},
		navigation: {
			nextEl: '.minihistoire .swiper-button-next',
			prevEl: '.minihistoire .swiper-button-prev'
		}
	});

	const swiperessource = new Swiper('.miniressource.swiper', {
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 15,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 30
			}
		},
		navigation: {
			nextEl: '.miniressource .swiper-button-next',
			prevEl: '.miniressource .swiper-button-prev'
		}
	});

	var map = document.getElementById('map');
	var paths = map.querySelectorAll('.map__image a');
	var links = map.querySelectorAll('.map__list a');

	var activeArea = function (id) {
		map.querySelectorAll('.active').forEach(function (item) {
			item.classList.remove('active');
		});

		if (id !== undefined) {
			var listId = document.getElementById('list-' + id);
			var regionId = document.getElementById('region-' + id);
			listId.classList.add('active');
			regionId.classList.add('active');
		}
	};

	paths.forEach(function (path) {
		path.addEventListener('mouseenter', function (e) {
			var id = this.id.replace('region-', '');
			activeArea(id);
		});
	});

	links.forEach(function (link) {
		link.addEventListener('mouseenter', function (e) {
			var id = this.id.replace('list-', '');
			activeArea(id);
		});
	});
	map.addEventListener('mouseleave', function () {
		activeArea();
	});

})(jQuery, Swiper);
